// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as CatalogRoutes from "../../app/Catalog/CatalogRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogProductMutations from "../../app/Catalog/CatalogProductMutations.res.js";
import * as CatalogVariantMutations from "./CatalogVariantMutations.res.js";
import * as CatalogProductArchiveModal from "./CatalogProductArchiveModal.res.js";

function CatalogProductPageActions(props) {
  let status = props.status;
  let id = props.id;
  let cku = props.cku;
  let scope = Auth.useScope();
  let activeShop = Auth.useActiveShop();
  let url = Navigation.useUrl();
  let match = React.useState(() => false);
  let setArchiveModalOpened = match[1];
  let unarchiveProduct = CatalogProductMutations.useUnarchive(id);
  let activateVariants = CatalogVariantMutations.useActivateMany();
  let deactivateVariants = CatalogVariantMutations.useDeactivateMany();
  let nonArchivedVariantIds = Stdlib_Array.filterMap(props.variants, variant => {
    let match = variant.status;
    if (typeof match === "object") {
      return;
    } else {
      return variant.id;
    }
  });
  let disabledKeysMenuActions = Stdlib_Option.isNone(activeShop) ? [
      "archive",
      "unarchive",
      "activate",
      "deactivate"
    ] : (
      nonArchivedVariantIds.length === 0 ? [
          "activate",
          "deactivate"
        ] : []
    );
  let archiveTooltipTextMenuActionsItem = Stdlib_Option.isNone(activeShop) ? I18n.t("Please select a shop beforehand.") : undefined;
  let saleTooltipTextMenuActionsItem = activeShop !== undefined ? (
      nonArchivedVariantIds.length !== 0 ? undefined : I18n.t("All product variants are archived.")
    ) : I18n.t("Please select a shop beforehand.");
  let tmp;
  tmp = scope.TAG === "Organisation" ? JsxRuntime.jsx(MenuActions.Item.make, {
      title: I18n.t("Duplicate"),
      href: CatalogRoutes.productDuplicationRoute(cku),
      icon: "duplicate_v2"
    }) : null;
  let tmp$1;
  let exit = 0;
  if (typeof status === "object") {
    tmp$1 = JsxRuntime.jsx(MenuActions.Item.make, {
      title: I18n.t("Unarchive"),
      tone: "brand",
      icon: "unarchive",
      tooltipText: archiveTooltipTextMenuActionsItem,
      onAction: () => {
        unarchiveProduct();
      }
    }, "unarchive");
  } else {
    exit = 1;
  }
  if (exit === 1) {
    let tmp$2;
    if (status !== undefined) {
      let exit$1 = 0;
      if (typeof status !== "object") {
        switch (status) {
          case "Inactive" :
            tmp$2 = JsxRuntime.jsx(MenuActions.Item.make, {
              title: I18n.t("Mark as on sale"),
              icon: "product_ok",
              tooltipText: saleTooltipTextMenuActionsItem,
              onAction: () => {
                activateVariants(nonArchivedVariantIds);
              }
            }, "activate");
            break;
          case "Active" :
          case "Unarchived" :
            exit$1 = 2;
            break;
        }
      } else {
        tmp$2 = null;
      }
      if (exit$1 === 2) {
        tmp$2 = JsxRuntime.jsx(MenuActions.Item.make, {
          title: I18n.t("Remove from sale"),
          icon: "product_nok",
          tooltipText: saleTooltipTextMenuActionsItem,
          onAction: () => {
            deactivateVariants(nonArchivedVariantIds);
          }
        }, "deactivate");
      }
    } else {
      tmp$2 = null;
    }
    tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        tmp$2,
        JsxRuntime.jsx(MenuActions.Item.make, {
          title: I18n.t("Archive"),
          tone: "danger",
          icon: "archive",
          tooltipText: archiveTooltipTextMenuActionsItem,
          onAction: () => setArchiveModalOpened(param => true)
        }, "archive")
      ]
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(Inline.make, {
        children: [
          JsxRuntime.jsxs(MenuActions.make, {
            children: [
              JsxRuntime.jsxs(MenuActions.Section.make, {
                children: [
                  JsxRuntime.jsx(MenuActions.Item.make, {
                    title: I18n.t("Edit"),
                    href: url.pathname + "/edit",
                    icon: "edit"
                  }),
                  tmp
                ]
              }),
              JsxRuntime.jsx(MenuActions.Section.make, {
                children: tmp$1
              })
            ],
            trigger: {
              TAG: "Normal",
              label: I18n.t("Actions")
            },
            disabledKeys: disabledKeysMenuActions
          }),
          JsxRuntime.jsx(Button.make, {
            label: I18n.t("New variant"),
            variant: "solid",
            tone: "brand",
            icon: "variant_add",
            href: CatalogRoutes.variantCreateRoute(cku)
          })
        ],
        space: "small"
      }),
      JsxRuntime.jsx(CatalogProductArchiveModal.make, {
        id: id,
        opened: match[0],
        onRequestClose: () => setArchiveModalOpened(param => false)
      })
    ]
  });
}

let make = React.memo(CatalogProductPageActions);

let Mutations;

export {
  Mutations,
  make,
}
/* make Not a pure module */
